exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.space{\n  display: inline-block;\n  width: 15px;\n}\n", "", {"version":3,"sources":["/tentcoo/jenkins/workspace/epm-prod-deploy-web-pc/src/components/dragTreeTable/space.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,YAAY;CACb","file":"space.vue","sourcesContent":["\n.space{\n  display: inline-block;\n  width: 15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-633f19e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dragTreeTable/space.vue
// module id = 9ZC1
// module chunks = 6